import React, { useState } from 'react';

import {
    makeStyles,
    Paper,
    Accordion,
    AccordionSummary,
    Grid,
    TableContainer,
    Table,
    TableBody,
    TableRow,
    TableCell,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { useSelector } from 'react-redux';

import moment from 'moment';

import styles from './styles';
const useStyles = makeStyles(styles);

function Summary() {
    const classes = useStyles();

    const [expanded, setExpanded] = useState(false);

    const { empresa: company, servico: service } = useSelector((state) => state.forms.internalNewRequest);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    return (
        <Paper>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Accordion
                        elevation={0}
                        square
                        expanded={expanded === 'summary'}
                        onChange={handleChange('summary')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="summarybh-content"
                            id="summarybh-header">
                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <TableContainer>
                                        <Table className={classes.tableInitialSummary} aria-label="simple table">
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell align="left" className={classes.borderNone}>
                                                        <h4 className={classes.summaryTitle}>Data solicitação</h4>
                                                        <h3 className={classes.summarySubtitle}>
                                                            {moment().format('DD/MM/YYYY')}
                                                        </h3>
                                                    </TableCell>
                                                    {company && company?.cdCertificado && (
                                                        <TableCell align="left" className={classes.borderNone}>
                                                            <h4 className={classes.summaryTitle}>Empresa</h4>
                                                            <h3 className={classes.summarySubtitle}>
                                                                cod.{' '}
                                                                {company.cdCertificado ? company.cdCertificado : ''} -{' '}
                                                                {company.cdTipoPessoaFisica
                                                                    ? company.nmCompleto || ''
                                                                    : company.deRazaoSocial || ''}
                                                            </h3>
                                                        </TableCell>
                                                    )}
                                                    <TableCell align="left" className={classes.borderNone}>
                                                        <h4 className={classes.summaryTitle}>Serviço</h4>
                                                        <h3 className={classes.summarySubtitle}>
                                                            {service?.nmServico ? service?.nmServico : ''}
                                                        </h3>
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                            </Grid>
                        </AccordionSummary>
                    </Accordion>
                </Grid>
            </Grid>
        </Paper>
    );
}

export default Summary;
